import { render } from "./ChartsComponent.vue?vue&type=template&id=4ad765d6"
import script from "./ChartsComponent.vue?vue&type=script&lang=js"
export * from "./ChartsComponent.vue?vue&type=script&lang=js"

import "./ChartsComponent.vue?vue&type=style&index=0&id=4ad765d6&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__